<template>
  <a-layout class="operationStatistics-body" style="height: 100%">
    <a-layout-sider
      width="360"
      style="background: #fff; min-width:360px; overflow:auto;"
      class="no-fix-sider"
    >
      <left-tree @search="(value) => seachValue(value)"></left-tree>
    </a-layout-sider>
    <div v-resize="'x'"></div>
    <a-layout-content style="height: 100%">
      <utilization-rate-list
        @pageIndexchange="(value) => pageIndexchange(value)"
        :total="total"
        :filters="filter"
        :timeName="timeName"
        :dataSource="dataSource"
        :advance="advance"
        @sorter="handleSorter"
      ></utilization-rate-list>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { StatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
const ssp = new StatisticsServiceProxy()
import LeftTree from './components/leftTree.vue'
import UtilizationRateList from './components/utilizationRateList.vue'
export default {
  components: {
    LeftTree,
    UtilizationRateList
  },
  data() {
    return {
      dataSource: [],
      total: 0,
      filter: {
        // 查询条件
        size: 50,
        current: 1
      },
      advance: {},
      timeName: '',
    }
  },
  methods: {
    pageIndexchange(value) {
      this.filter.current = value
      this.getList()
    },
    handleSorter(data) {
      this.advance = {...this.advance, ...data};
      this.getList();
    },
    async seachValue(value) {
      this.filter.current = 1
      this.advance = {...this.advance,...value}
      this.timeName = this.advance.startDate + '-' + this.advance.endDate
      this.getList()
    },
    async getList() {
      console.log(this.advance)
      const data = await ssp.getWeeklyEfficiencyData(
        this.filter.current,
        this.advance,
        this.filter.size,
      )
      if (data.records && data.records.length) {
        this.dataSource = data.records.map((res, index) => {
          const add = { ...res }
          add.key = res.id
          return add
        })
      } else {
        this.dataSource = []
      }
      this.total = data.total
    }
  }
}
</script>

<style lang="scss" scoped></style>
